module.exports = __webpack_public_path__ + "img/31.6a7b98d9.jpg";